import { Plus } from "@phosphor-icons/react";

import useIsDesktop from "@/hooks/useIsDesktop";
export default function FAB({ onClick }) {
  const isDesktop = useIsDesktop();
  if (isDesktop) return null;
  return (
    <button
      data-testid="fab-create"
      onClick={onClick}
      className="fixed z-40 bottom-24 right-5 w-14 h-14 rounded-full bg-[#005CFF] text-white flex items-center justify-center shadow-[0_10px_40px_-6px_rgba(0,92,255,0.7)] active:scale-90 hover:bg-[#0047CC] transition-[transform,background-color]"
      aria-label="Créer"
    >
      <Plus size={26} weight="bold" />
    </button>
  );
}
